export default "__VITE_ASSET__2186917b__"